import styled from 'styled-components';

import { StyledProps } from '../../types';
import { SupplementButton, InlineButton } from 'src/commons/components/Button';
import Card from 'src/commons/components/Card';
import FileDownloadLink from 'src/commons/components/FileDownloadLink';
import {
  colors,
  CARD_BREAKPOINT,
  MOBILE_BREAKPOINT,
} from 'src/commons/constants';

// Style container for displaying Plaid OnExit callback
export const BankErrorCard = styled(Card)`
  border-left: 0.3125rem solid ${colors.TEXT_ERROR};
  display: grid;
  grid-template-columns: 2fr 1fr;
  margin-bottom: 0.6875rem;
  min-height: 6rem;
  padding: 1.4375rem 0;
  @media (max-width: ${CARD_BREAKPOINT}) {
    border-left: none;
    border-top: 0.3125rem solid ${colors.TEXT_ERROR};
    display: flex;
    margin-top: 0.625rem;
    padding: 1.3125rem 0 1.5rem;
    width: calc(100% - 1.25rem);
  }
`;

export const PlaidErrorCard = styled(BankErrorCard)`
  grid-template-columns: unset;
  min-height: 5.25rem;
  padding: 1.125rem 0;
`;

export const BankErrorContainer = styled.div`
  line-height: 1.5rem;
  padding-left: 1.6875rem;
  text-align: left;
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin-bottom: 1.25rem;
    padding: 0 1rem;
    text-align: center;
  }
`;

export const PlaidErrorContainer = styled(BankErrorContainer)`
  padding: 0 1rem 0 1.6875rem;
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin: 0;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 0 1.25rem;
  }
`;

export const BankErrorHeading = styled.h1`
  color: ${colors.TEXT_PRIMARY};
  font-size: 1.125rem;
  font-weight: 500;
  @media (max-width: ${CARD_BREAKPOINT}) {
    font-size: 1rem;
  }
`;

export const PlaidErrorHeading = styled(BankErrorHeading)`
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
`;

export const BankErrorSubHeading = styled.p`
  color: ${colors.TEXT_SECONDARY};
  font-size: 1rem;
  font-weight: 400;
`;

// Bias the button to the right of the second grid column
export const BankErrorDetailsButton = styled(SupplementButton)`
  justify-self: right;
  margin-right: 1.75rem;
  font-weight: 600;
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin-right: 0;
  }
`;

export const BankAuthorizationAgreement = styled.p`
  color: ${colors.TEXT_PRIMARY};
  font-size: 0.8125rem;
  font-weight: 400;
  padding: 0 1rem;
  text-align: center;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 0.375rem 1rem 1rem;
  }
`;

export const BankAuthorizationAgreementDownloadLink = styled(FileDownloadLink)`
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5rem;
`;

export const AutoPayActionsContainer = styled.div<StyledProps>`
  width: 100%;
  max-width: 25rem;
  margin: 0.75rem 0 2.4375rem;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  ${(p: StyledProps) =>
    p.shorterBottomMargin &&
    `
    margin: 0.75rem 0 1.8125rem;
  `};
`;

export const PlaidLinkButtonContainer = styled.div`
  margin: 0 0 0.0625rem;
  max-width: 25rem;
  width: 100%;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0 0 0.5rem;
    padding: 0;
  }
`;

export const DeclineButton = styled(InlineButton)`
  margin: 1.5rem 1rem;
  color: ${colors.TEXT_ANCHOR};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  &:focus:not(:hover, :focus-visible) {
    text-decoration: none;
    outline: none;
    margin: 1.5rem 1rem;
    padding: auto;
  }
  &:focus-visible {
    text-decoration: none;
    outline: 0.125rem solid ${colors.UI_SECONDARY_ACCENT};
    border-radius: 0.125rem;
    padding: 0.0625rem;
    margin: 1.4375rem 1rem;
  }
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin: 1rem 1rem 1.1875rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 1rem 1rem 0;
  }
`;
